var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgViewlogs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "history (1) 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer 2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19 22.75H5C4.53604 22.7494 4.09125 22.5649 3.76319 22.2368C3.43512 21.9087 3.25056 21.464 3.25 21V3C3.25056 2.53604 3.43512 2.09125 3.76319 1.76319C4.09125 1.43512 4.53604 1.25056 5 1.25H19C19.464 1.25056 19.9087 1.43512 20.2368 1.76319C20.5649 2.09125 20.7494 2.53604 20.75 3V21C20.7494 21.464 20.5649 21.9087 20.2368 22.2368C19.9087 22.5649 19.464 22.7494 19 22.75ZM5 2.75C4.93373 2.75013 4.87022 2.77651 4.82336 2.82336C4.77651 2.87022 4.75013 2.93373 4.75 3V21C4.75013 21.0663 4.77651 21.1298 4.82336 21.1766C4.87022 21.2235 4.93373 21.2499 5 21.25H19C19.0663 21.2499 19.1298 21.2235 19.1766 21.1766C19.2235 21.1298 19.2499 21.0663 19.25 21V3C19.2499 2.93373 19.2235 2.87022 19.1766 2.82336C19.1298 2.77651 19.0663 2.75013 19 2.75H5Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M16.5 18.75H10.5C10.3011 18.75 10.1103 18.671 9.96967 18.5303C9.82902 18.3897 9.75 18.1989 9.75 18C9.75 17.8011 9.82902 17.6103 9.96967 17.4697C10.1103 17.329 10.3011 17.25 10.5 17.25H16.5C16.6989 17.25 16.8897 17.329 17.0303 17.4697C17.171 17.6103 17.25 17.8011 17.25 18C17.25 18.1989 17.171 18.3897 17.0303 18.5303C16.8897 18.671 16.6989 18.75 16.5 18.75Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M7.5 19C8.05228 19 8.5 18.5523 8.5 18C8.5 17.4477 8.05228 17 7.5 17C6.94772 17 6.5 17.4477 6.5 18C6.5 18.5523 6.94772 19 7.5 19Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M16.5 14.75H10.5C10.3011 14.75 10.1103 14.671 9.96967 14.5303C9.82902 14.3897 9.75 14.1989 9.75 14C9.75 13.8011 9.82902 13.6103 9.96967 13.4697C10.1103 13.329 10.3011 13.25 10.5 13.25H16.5C16.6989 13.25 16.8897 13.329 17.0303 13.4697C17.171 13.6103 17.25 13.8011 17.25 14C17.25 14.1989 17.171 14.3897 17.0303 14.5303C16.8897 14.671 16.6989 14.75 16.5 14.75Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M7.5 15C8.05228 15 8.5 14.5523 8.5 14C8.5 13.4477 8.05228 13 7.5 13C6.94772 13 6.5 13.4477 6.5 14C6.5 14.5523 6.94772 15 7.5 15Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M16.5 10.75H10.5C10.3011 10.75 10.1103 10.671 9.96967 10.5303C9.82902 10.3897 9.75 10.1989 9.75 10C9.75 9.80109 9.82902 9.61032 9.96967 9.46967C10.1103 9.32902 10.3011 9.25 10.5 9.25H16.5C16.6989 9.25 16.8897 9.32902 17.0303 9.46967C17.171 9.61032 17.25 9.80109 17.25 10C17.25 10.1989 17.171 10.3897 17.0303 10.5303C16.8897 10.671 16.6989 10.75 16.5 10.75Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M7.5 11C8.05228 11 8.5 10.5523 8.5 10C8.5 9.44772 8.05228 9 7.5 9C6.94772 9 6.5 9.44772 6.5 10C6.5 10.5523 6.94772 11 7.5 11Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M13.5 6.75H10.5C10.3011 6.75 10.1103 6.67098 9.96967 6.53033C9.82902 6.38968 9.75 6.19891 9.75 6C9.75 5.80109 9.82902 5.61032 9.96967 5.46967C10.1103 5.32902 10.3011 5.25 10.5 5.25H13.5C13.6989 5.25 13.8897 5.32902 14.0303 5.46967C14.171 5.61032 14.25 5.80109 14.25 6C14.25 6.19891 14.171 6.38968 14.0303 6.53033C13.8897 6.67098 13.6989 6.75 13.5 6.75Z",
    fill: "#787878"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M7.5 7C8.05228 7 8.5 6.55228 8.5 6C8.5 5.44772 8.05228 5 7.5 5C6.94772 5 6.5 5.44772 6.5 6C6.5 6.55228 6.94772 7 7.5 7Z",
    fill: "#787878"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewlogs);
export default __webpack_public_path__ + "static/media/Viewlogs.2f6f0fced702038464f12a14c2390bb2.svg";
export { ForwardRef as ReactComponent };